import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import globalStyle from "./../../globalStyle";

const CustomDropDown = ({
  icon,
  children,
  placehoder,
  formStyleProps = {},
  selectError = false,
  helperText,
  ...props
}) => {
  return (
    <FormControl
      fullWidth
      sx={{ ...globalStyle.selectDropDown, ...formStyleProps }}
      error={selectError}
    >
      <InputLabel>{placehoder}</InputLabel>
      <Select
        startAdornment={
          icon && <InputAdornment position="start">{icon}</InputAdornment>
        }
        {...props}
      >
        {children}
      </Select>
      {selectError && (
        <FormHelperText sx={{ ml: 0 }}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default CustomDropDown;
